<div class="container">
  <div class="row no-side-margin">
    <div class="col-12 no-padding">
      <app-telekom-header slot="header"></app-telekom-header>
      <app-body></app-body>
      <app-footer slot="footer"></app-footer>
    </div>
  </div>
</div>
